import React from 'react';

import LayerSwitcherElement from './LayerSwitcherElement';

const LayerSwitcher = (props) => {
  const layers = [...props.layers].reverse();

  return (
    <ul>
      {layers.map((layer, index) => {
        return (
          <LayerSwitcherElement
            key={index}
            id={layer.get('title')}
            layer={layer}
          />
        );
      })}
    </ul>
  );
};

export default LayerSwitcher;
